import ComparativoMPVentasClass from './ComparativoMPVentasClass';

export default ComparativoMPVentasClass
